import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d29e13e6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d29e13e6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d29e13e6')) {
      api.createRecord('d29e13e6', component.options)
    } else {
      api.reload('d29e13e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d29e13e6", function () {
      api.rerender('d29e13e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/sdk-universal-config/index.vue"
export default component.exports